// Package
import React from 'react';
import PropType from 'prop-types';

//Stytes
import { StyledCardWrapper } from './CardWrapper.styles'

const CardWrapper = (props) => {
  const { children, widthContent = "100%", className, padding = "4rem" } = props;

  return (
    <StyledCardWrapper
      padding={ padding }
      className={ className }
      widthContent={ widthContent }
    >
      { children }
    </StyledCardWrapper>
  )
}

CardWrapper.propType = {
  widthContent: PropType.string,
  className: PropType.string,
  padding: PropType.string
}

export default CardWrapper;